import { $ } from './utils'
;(() => {
  const notificationsWrapper = $('.site-header .site-notifications')
  if (!notificationsWrapper) return

  const notificationsBtn = $('.toggle-header-notifications', notificationsWrapper)
  const notificationsSection = $('.header-notifications', notificationsWrapper)

  const isNotificationsSectionToggled = () => notificationsSection.classList.contains('toggled')

  const toggleNotificationsSection = () => {
    let toggled = isNotificationsSectionToggled()
    toggled = !toggled

    notificationsSection.classList.toggle('toggled')
    toggled ? notificationsSection.removeAttribute('hidden') : notificationsSection.setAttribute('hidden', '')

    notificationsSection.setAttribute('aria-hidden', toggled ? 'false' : 'true')
    notificationsBtn.setAttribute('aria-expanded', toggled ? 'true' : 'false')

    notificationsBtn.classList.add('read')
    if (!toggled) {
      notificationsBtn.focus()
    }
  }

  notificationsBtn.addEventListener('click', () => toggleNotificationsSection())

  notificationsWrapper.addEventListener('keyup', (e) => {
    if (e.code === 'Escape') {
      toggleNotificationsSection()
    }
  })
})()
